import Api from "@/utils/api";

const state = {
  todos: [],
  todo: {},
};
const getters = {
  getTodos(state) {
    return state.todos;
  },
  getTodo(state) {
    return state.todo;
  },
};
const mutations = {
  setTodos(state, data) {
    return (state.todos = data);
  },
  setTodo(state, data) {
    return (state.todo = data);
  },
};
const actions = {
  async createTodo({ commit }, payload) {
    let res = await Api.post("/todo", payload, true);
    return res;
  },
  async getPerformance({ commit }, payload) {
    let res = await Api.get(`/fetch-learner-performance?week=${payload.week}`);
    return res;
  },
  async fetchTodos({ commit }, payload) {
    let res = await Api.get("/todo", true);
    commit("setTodos", res.data.data.todo);
    return res;
  },
  async fetchTodo({ commit }, payload) {
    let res = await Api.get(`/todo/${payload.id}`, true);
    //console.log({ sssss: res });
    commit("setTodo", res.data.data.todo);
    return res;
  },
  async updateTodo({ commit }, payload) {
    // let { data, id } = payload;xx
    // //console.log(payload)
    let res = await Api.put(`/todo/${payload.id}`, payload, true);
    return res;
  },
  async deleteTodo({ commit }, payload) {
    let res = await Api.delete(`/todo/${payload.id}`, true);
    return res;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
